module.exports = __webpack_public_path__ + "static/media/iconEditModal.115bfe7a.svg";